import * as React from 'react'

export interface IHoverFocusState {
  isHovered: boolean
  isFocused: boolean
}

interface IProps extends React.HTMLAttributes<any> {
  children: (state: IHoverFocusState) => React.ReactNode
}

class HoverFocusObserver extends React.Component<IProps, IHoverFocusState> {
  private $element: HTMLSpanElement | null

  constructor(props: IProps) {
    super(props)

    this.state = { isHovered: false, isFocused: false }
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.$element = null
  }

  public componentDidUpdate() {
    this.syncFocusStateForMobile()
  }

  public render() {
    const { children, ...restProps } = this.props
    return (
      <span
        ref={$element => (this.$element = $element)}
        role="group"
        {...restProps}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      >
        {children(this.state)}
      </span>
    )
  }

  private onMouseEnter() {
    this.setState({ isHovered: true })
  }

  private onMouseLeave() {
    this.setState({ isHovered: false })
  }

  private onFocus() {
    this.setState({ isFocused: true })
  }

  private onBlur() {
    this.setState({ isFocused: false })
  }

  private syncFocusStateForMobile() {
    if (this.$element) {
      if (
        this.$element.contains(document.activeElement) &&
        !this.state.isFocused
      ) {
        this.setState({ isFocused: true })
      }

      if (
        !this.$element.contains(document.activeElement) &&
        this.state.isFocused
      ) {
        this.setState({ isFocused: false })
      }
    }
  }
}

export default HoverFocusObserver
